import { matchPath } from "react-router-dom";

/**
 * Is this pathname the report dashboard for the given company?
 *
 * Deliberately narrow: only `/reports/:companyId` and
 * `/reports/:companyId/:reportId` count. The sub-pages that share the prefix
 * (`/sources`, `/workbench`) are places the user is *doing* something, and the
 * completion handover must not pull them out of active work — see
 * `useAwaitedReport`.
 */
export const isCompanyDashboardPath = (
  pathname: string,
  companyId: number,
): boolean => {
  const withReport = matchPath("/reports/:projectId/:reportId", pathname);
  if (withReport) {
    const { projectId, reportId } = withReport.params;
    // `/reports/107/sources` parses as reportId="sources" here — it's a
    // literal sibling route, not a report on the dashboard.
    return projectId === String(companyId) && /^\d+$/.test(reportId ?? "");
  }
  return (
    matchPath("/reports/:projectId", pathname)?.params.projectId ===
    String(companyId)
  );
};
